import store from '@/store';
import hasPermission from '@/utils/hasPermission';

export default async (to, from, next) => {
  let hasCorrectPermission = false;
  const { me } = store.state.users;

  if (!me?.id) {
    const meUser = await store.dispatch('users/me');
  }

  hasCorrectPermission = store.state?.users?.me
    ? hasPermission(store.state?.users?.me, to?.meta?.requiresPermission)
    : false;

  if (to?.meta?.requiresPermission?.length > 0) {
    if (hasCorrectPermission) {
      next();
    } else {
      next('/not-authorized');
    }
  }
};
